import { env } from "./env";
import { defaultClientId, groupId } from "./ClientSelection";

// wcClient is a REAL client id (5811997, Sarvodaya Agencies Udupi) - used by
// the customer login and the public pages.
//
// groupId (_SARVODAYA) is the GROUP. It identifies the group client list
// (GET /api/OwnAppConfigs/GroupClientList/{GroupId}) and it is also the
// wClientId the ordering screens send - Order, Order Upload and Order by
// Comp all place their orders against the group, not a single firm.
//
// The company screens and the customer reports pick a member firm from that
// list and use its own id; see ClientSelection.getSelectedClientId and
// getReportFirmId.
const GlobalVariable = {
    wcClient: defaultClientId,
    groupId: groupId,
    ReliableSoftURL: env.REACT_APP_BASE_URL
};
export default GlobalVariable;
